import { render, staticRenderFns } from "./VotingMasterListPerson.vue?vue&type=template&id=2d1beef7&"
import script from "./VotingMasterListPerson.vue?vue&type=script&lang=js&"
export * from "./VotingMasterListPerson.vue?vue&type=script&lang=js&"
import style0 from "./VotingMasterListPerson.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports